export { default } from "./NewsDispensariesCarousel";
